module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list-item', {
    staticClass: "ql-layer-menu-item"
  }, [_c('md-icon', {
    staticClass: "ql-color-picker-choice",
    style: (_vm.style())
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.layer.title))]), _vm._v(" "), _c('md-button', {
    on: {
      "click": _vm.deleteLayer
    }
  }, [_c('md-icon', [_vm._v("delete")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44990cec","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layers/layer-lite.vue
// module id = 1235
// module chunks = 21